<template>
    <div>
        <signature-popup :popupConfig="popupSignature" :key="signatureKey + 'popuphistory'"></signature-popup>
        <!-- <vs-popup v-if="popupConfig && popupConfig.item_info && popupConfig.item_info.customer" class="signature-popup" :title="popupConfig.item_info.customer.full_name" :active.sync="popupSignature.isOpen">
            <div class="vx-row h-full px-6 customer-signature-content">
                <img :src="popupConfig.item_info.check_in.attachment" width="640" height="400">
            </div>
        </vs-popup> -->
        <vs-popup class="checkout-history-popup" title="Checkout History" :active.sync="popupConfig.isOpen">
        <div class="vx-row h-full px-6 checkout-history-popup-content">
            <div class="vx-col custom-col pr-0 lg:pr-6 pl-0 lg:w-5/12 w-full content-1" v-if="popupConfig.item_info.customer">
                <div class="vx-row flex align-center">
                    <div>
                        <vs-avatar class="text-3xl font-bold" size="80px" :text="StringHelper.changeFormatAvatar(popupConfig.item_info.customer.full_name)"/>
                    </div>
                    <div class="ml-2">
                        <!-- <div class="font-bold text-2xl customer-name">{{popupConfig.item_info.customer.full_name}}</div> -->
                        <div class="tooltip">
                            <vs-button class="font-bold text-2xl customer-name" @click.stop>{{popupConfig.item_info.customer.full_name}}</vs-button>
                            <span class="tooltiptext" style="word-wrap: break-word; word-break: break-word;">{{popupConfig.item_info.customer.full_name}}</span>
                        </div>
                        <div class="flex">
                            <!-- <i class="material-icons text-base">phone</i> -->
                            <feather-icon icon="PhoneIcon" svgClasses="h-5 w-5 mr-1" />
                            {{StringHelper.phoneNumberFormat(popupConfig.item_info.customer.phone, true)}}
                        </div>
                        <div class="my-2">
                            <vs-alert class="text-center" active="true" :color="getMemberTypeColor(popupConfig.item_info.customer.type)" style="width: 80px">{{popupConfig.item_info.customer.type}}</vs-alert>
                        </div>
                    </div>
                </div>
                <vs-divider></vs-divider>
                <div class="vx-row">
                    <div class="vx-col w-1/2 mb-3">
                        <div class="text-grey-custom">Points</div>
                        <p class="pt-2">{{popupConfig.item_info.customer.current_point}} Pts</p>
                    </div>
                    <div class="vx-col w-1/2 mb-3">
                        <div class="text-grey-custom">Visit</div>
                        <p class="pt-2" v-if="popupConfig.item_info.customer.number_checkin > 1">{{popupConfig.item_info.customer.number_checkin}} times</p>
                        <p class="pt-2" v-else>{{popupConfig.item_info.customer.number_checkin}} time</p>
                    </div>
                    <div class="vx-col w-1/2 mb-3">
                        <div class="text-grey-custom">Check in</div>
                        <p class="pt-2" v-if="popupConfig.item_info.check_in && popupConfig.item_info.check_in.create_at">{{changeFormat(popupConfig.item_info.check_in.create_at)}}</p>
                        <p class="pt-2" v-else>N/A</p>
                    </div>
                    <div class="vx-col w-1/2 mb-3">
                        <div class="text-grey-custom">Check out</div>
                        <p class="pt-2" v-if="popupConfig.item_info.update_at">{{changeFormat(popupConfig.item_info.update_at)}}</p>
                        <p class="pt-2" v-else>N/A</p>
                    </div>
                </div>

                <div>
                    <p class="pt-0 pb-3 leading-normal text-grey-custom">Note</p>
                    <vs-textarea class="textarea-note" :maxlength="1024" v-model="note" height="200px" v-on:keypress="has_updated=false"/>
                </div>
                <div class="flex">
                    <!-- <btn-custom type="border" class="mr-3 ml-0" @click="refreshNote">Refresh</btn-custom> -->
                    <vs-dropdown vs-trigger-click class="cursor-pointer vx-col w-custom" style="width: 157px;">
                        <div class="px-3 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-center font-medium" style="height: 38px">
                            <span class="font-bold text-sm px-2">MORE OPTIONS</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu class="dropdown-appointment">
                            <vs-dropdown-item @click="refreshNote">
                                <span>Refresh</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="viewSignature" v-if="popupConfig.item_info.check_in && popupConfig.item_info.check_in.attachment">
                                <span>View signature</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="reprint()">
                                <span>Re-print</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item v-if="popupConfig.item_info.invoice">
                                <span @click="sendInvoice">Send invoice</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                    <btn-custom type="filled" @click="updateNote" style="width: 157px; margin-right: 0; margin-left: 18px">Save</btn-custom>
                </div>
                <!-- <div class="flex">
                    <btn-custom type="border" class="mr-3 ml-0">Send invoice</btn-custom>
                    <btn-custom type="filled" >Re-print</btn-custom>
                </div> -->
            </div>

            <div class="vx-col custom-col lg:mt-0 mt-6 border-left-custom pr-0 pl-6 lg:w-7/12 w-full content-2 position-relative right-content">
                <div class="w-full border-bottom-custom overflow-auto" style="height: 85px;">
                    <div class="h-full" v-if="popupConfig.item_info">
                        <div class="flex justify-between" v-if="popupConfig.item_info.survey">
                            <div>
                                <div class="text-grey-custom pb-2">Customer survey</div>
                                <div class="pb-2">
                                    <star-rating v-if="popupConfig.item_info.survey.rating" :rating="popupConfig.item_info.survey.rating" :read-only="true" :increment="1" class="mr-3" :star-size="20" :show-rating="false"></star-rating>
                                    <star-rating v-else :rating="0" :read-only="true" :increment="1" class="mr-3" :star-size="15" :show-rating="false"></star-rating>
                                </div>
                                <div v-if="popupConfig.item_info.survey.comment">{{popupConfig.item_info.survey.comment}}</div>
                            </div>
                            <div class="text-warning">{{popupConfig.item_info.survey.status}}</div>
                        </div>
                        <div class="flex justify-center align-center text-2xl h-full pb-4" v-else>No survey</div>
                    </div>
                </div>
                <!-- <label class="text-grey-custom mt-4 mb-1 block">Staff name:</label>
                <div v-if="popupConfig.item_info.staff">{{popupConfig.item_info.staff.name}}</div>
                <div v-else>No staff</div> -->
                <label class="text-grey-custom mt-4 mb-1 block">Service - staff:</label>
                <div class="overflow-hidden rounded-item">
                    <div class="redeem border-custom w-full rounded-item p-3">
                        <div v-if="popupConfig.item_info.check_in && popupConfig.item_info.check_in.customer_checkin_services &&
                                    popupConfig.item_info.check_in.customer_checkin_services.length > 0">
                            <vx-card class="my-3" v-for="(item, item_index) in popupConfig.item_info.check_in.customer_checkin_services" :key="item_index">
                                <div class="flex">
                                    <span class="text-primary mr-2" v-if="item.service">{{item.service.name}} </span> 
                                    <span class="mr-2" v-else>no service</span>
                                     with
                                    <span class="text-primary ml-2" v-if="item.staff">
                                        {{item.staff.name}}
                                    </span>
                                    <span class="ml-2" v-else>no staff</span>
                                </div>
                            </vx-card>
                        </div>
                        <div v-else>
                            No service
                        </div>
                    </div>
                </div>
                <!-- <div>
                  {{staff_name}}
                </div> -->
                <label class="text-grey-custom mt-4 mb-1 block">Promotion:</label>
                <div v-if="popupConfig.item_info.promotion">{{popupConfig.item_info.promotion.name}}</div>
                <div v-else>No promotion</div>


                <label class="text-grey-custom mt-4 mb-2 block">Redeem:</label>
                <!-- <vs-textarea v-model="redeem" height="200" disabled/> -->
                <div class="overflow-hidden rounded-item">
                    <div class="redeem border-custom w-full rounded-item p-3" v-if="popupConfig.item_info.redeem">
                        <div v-if="popupConfig.item_info.redeem.length > 0">
                            <vx-card class="my-3 is-selected" v-for="(redeem, index) in popupConfig.item_info.redeem" :key="index">
                                <div class="flex justify-between w-full" v-if="redeem.content">
                                    {{redeem.content.content}}
                                    <feather-icon icon="CheckIcon" svgClasses="w-4 h-4 stroke-current text-primary" />
                                </div>
                            </vx-card>
                        </div>
                        <div v-else>No redeem</div>
                    </div>
                    <!-- <div class="redeem border-custom w-full rounded-item p-3" v-if="popupConfig.item_info.listRedeem">
                        <div v-if="popupConfig.item_info.listRedeem.length > 0">
                            <vx-card class="my-2" v-for="(redeem, index) in popupConfig.item_info.listRedeem" :key="index">
                                <div class="flex justify-between align-center">
                                    <div>{{redeem.content}}</div>
                                    <div>
                                        <span v-if="redeem.logic_type=='usd'">-${{redeem.logic_value}}</span>

                                        <span v-else>-{{redeem.logic_value}}%</span>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                        <div v-else>No redeem</div>
                    </div> -->
                </div>
                <div class="mt-base w-full pl-6 bottom-right-content">
                    <div class="flex justify-between">
                        <div>Pay</div>
                        <div>${{popupConfig.item_info.total_price}}</div>
                    </div>
                    <div class="flex justify-between mt-2">
                        <div>Point</div>
                        <div v-if="popupConfig.item_info.point_bonus > 0">+{{popupConfig.item_info.point_bonus}}</div>
                        <div v-else>+0</div>
                    </div>
                    <vs-button class="w-full m-0 mt-4" type="border" color="danger" @click="closePopup">Close</vs-button>
                </div>
            </div>
        </div>
        </vs-popup>
        
    </div>
</template>

<script>
    // import moment from 'moment';
    import { StringHelper } from '../../models/string_helper'
    import StarRating from "vue-star-rating";
    import {changeFormatWithDateTime} from '../../helper/datetimeHelper';
    export default {
        name: 'checkout-history-popup',
        components: {
            StarRating
        },
        props: {
            popupConfig: {
                type: Object,
                required: true
            },
            currentPage: {
                type: Number,
                default: 1
            },
            itemsPerPage: {
                type: Number,
                default: 10
            },
            search: {
                type: String,
            },
            filter: {
                type: Object,
            }
        },
        data() {
            let staff_name = '';
            if(this.popupConfig && this.popupConfig.item_info && this.popupConfig.item_info.invoice && this.popupConfig.item_info.invoice.invoice_details){
              for(let i= 0; i< this.popupConfig.item_info.invoice.invoice_details.length;i++){
                if(this.popupConfig.item_info.invoice.invoice_details[i].employee_name != null){
                  staff_name = staff_name + this.popupConfig.item_info.invoice.invoice_details[i].employee_name + ', '
                }else{
                  staff_name = staff_name + '';
                }
              }
            }else{
              staff_name = 'No staff'
            }
            if(staff_name.replace(/,\s*$/, "") == ''){
              staff_name = 'No staff'
            }else{
              staff_name = staff_name.replace(/,\s*$/, "");
            }
            let note_temp = '';
            let first_note = '';
            // if(this.popupConfig.item_info) {
                if(this.popupConfig.item_info && this.popupConfig.item_info.customer) {
                    // this.note_temp = this.popupConfig.note;
                    note_temp = this.popupConfig.item_info.customer.note;
                    first_note = this.popupConfig.item_info.customer.note;
                }
            // }
            return {
                StringHelper,
                note_temp,
                has_updated: false,
                first_note,
                staff_name,
                popupSignature: {
                    title: "Signature",
                    isOpen: false,
                    attachment: null
                },
                signatureKey: 50000
            }
        },
        watch:{
            popupConfig: {
                immediate: true,
                deep: true,
                handler() {
                    if(this.popupConfig.isOpen) {
                        document.body.classList.add('overflow-hidden');
                        document.body.style.position = '';
                        document.body.style.top = '';
                        window.scrollTo(0, parseInt(scrollY || '0') * -1);
                        if(this.popupConfig.item_info.customer) {
                            this.note_temp = this.popupConfig.item_info.customer.note;
                        }
                    } else {
                        document.body.classList.remove('overflow-hidden');
                    }
                }
            }
        },
        computed: {
            note: {
                get() {
                    return this.note_temp;
                },
                set(value) {
                    this.note_temp = value;
                }
            }
        },
        methods: {
            openLoadingInDiv(){
              this.$vs.loading({
                container: '#app',
                scale: 0.8
              })
              if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
              }
              this.isOpenLoading = true;
              this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                  this.closeLoading();
                  this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: 'Send Invoice Failed',
                    acceptText: 'OK'
                  })
                }
              }, 10000);
            },
            closeLoading() {
              this.isOpenLoading = false;
              setTimeout( ()=> {
                this.$vs.loading.close('#app > .con-vs-loading')
              }, 500);
            },
            sendInvoice(){
              this.openLoadingInDiv();
              const obj = {
                id : this.popupConfig.item_info.invoice.id,
                email: this.popupConfig.item_info.customer.email
              }
              this.$store.dispatch("invoiceList/SEND_INVOICE" , obj).then(() => {
                this.closeLoading();
                this.$vs.notify({
                  title:'Notification',
                  text:'Send Success To ' + obj.email,
                  color:'success',
                  position:'top-right'})
              }).catch((e) => {
                this.$vs.notify({
                  title:'Notification',
                  text: e,
                  color:'danger',
                  position:'top-right'})
              })
            },
            closePopup() {
                this.$emit('CloseHistoryPopup');
            },
            changeFormat(day){
                if(day) {
                    return changeFormatWithDateTime(day);
                } else {
                    return 'N/A';
                }
            },
            // closePopup(){
            //   this.popupConfig.isOpen = false;
            // },
            getMemberTypeColor(member_type) {
                if (member_type == "new") return "success";
                if (member_type == "regular") return "primary";
                if (member_type == "vip") return "danger";
                if (member_type == "atrisk") return "warning";
                return "purple";
            },
            refreshNote() {
                // if(this.popupConfig.item_info.customer && this.has_updated == false) {
                //     // this.note_temp = this.popupConfig.item_info.customer.note;
                //     this.note_temp = this.first_note;
                // }
                this.$emit('Refresh');
            },
            updateNote() {
                if(this.popupConfig.item_info && this.popupConfig.item_info.customer) {
                    const obj = {
                        phone: this.popupConfig.item_info.customer.phone,
                        note: this.note,
                        page: this.currentPage,
                        "per-page": this.itemsPerPage,
                        id: this.popupConfig.item_info.id,
                        keyword: this.search,
                    }
                    if(this.filter && this.filter.id != 1) {
                        obj.type = this.filter.name;
                    }
                    this.$store.dispatch('checkin/UPDATE_CUSTOMER_NOTE', obj).then(() => {
                        this.$vs.notify({
                        title:'Notification',
                        text:'Update Customer Note Successful',
                        color:'success',
                        position:'top-right'});
                        this.has_updated = true;
                        this.first_note = this.note;
                        this.$emit('UpdateNote');
                    }).catch(() => {
                        this.$vs.notify({
                        title:'Notification',
                        text:'Update Customer Note Fail',
                        color:'danger',
                        position:'top-right'})
                    })
                }
            },
            reprint(){
                let link = 'gocheckin://' + this.popupConfig.item_info.checkin_id
                window.location.href = link;
            },
            viewSignature() {
                this.popupSignature.title = (this.popupConfig.item_info.customer) ? this.popupConfig.item_info.customer.full_name : "Signature";
                this.popupSignature.attachment = (this.popupConfig.item_info.check_in) ? this.popupConfig.item_info.check_in.attachment : null;
                if (this.popupSignature.attachment != null){
                    this.signatureKey++;
                    this.popupSignature.isOpen = true;
                }
            }
        }
    }
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/_variables';
    .checkout-history-popup {
        //  .vs-popup {
        //      height: 100vh;
        //     .vs-popup--content {
        //         // height: 100vh;
        //         max-height: unset !important;
        //         // padding-bottom: 20px;
        //     }
        //  }
        .bottom-right-content {
            position: absolute;
            bottom: 10px;
            left: 0;
        }
        .is-selected {
            -webkit-transform: translate(0)!important;
            transform: translate(0)!important;
            background: rgba($primary,.05)!important;
        }

        .textarea-note {
            .vs-textarea {
                height: 200px;
            }
            overflow: hidden;
        }

        .is-selected {
            color: rgba($primary,1);
            -webkit-box-shadow: 0 0 1px 0 rgba($primary,1)!important;
            box-shadow: 0 0 1px 0 rgba($primary,1)!important;
        }
        @media (max-width: 991px) {
            .right-content {
                padding-left: 0 !important;
                border: none;
                .bottom-right-content {
                    position: relative;
                    padding-left: 0 !important;
                }
            }
        }
        .redeem {
            height: 7rem;
            overflow-y: auto;
            padding-top: 5px;
            .vx-card__body {
                padding: 10px;
            }
        }
        // .text-xl {
        //     .vs-textarea {
        //         font-size: 1.25rem;
        //         font-weight: 450;
        //     }
        // }
    }
</style>
